import Firebase from 'firebase'

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);

  
const firebaseApp = Firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.database();


